import { useQuery } from "@tanstack/react-query";
import type {
  StrandLossCategory,
  StrandLossCode,
} from "../../models/StrandAsset";
import {
  getStrandLossCategories,
  getStrandLossCodes,
} from "../../repositories/StrandLossesManagerRepository";

export const useStrandLossCategoriesQuery = (parentAssetId: number | null) =>
  useQuery({
    queryKey: ["strand-loss-categories", parentAssetId],
    meta: { realtime: ["DEL.GetDelayCategories"] },
    queryFn: async ({ signal }): Promise<StrandLossCategory[]> => {
      const response = await getStrandLossCategories(parentAssetId!, signal);
      if (!response.ok) {
        throw new Error(
          response.message ?? "Failed to fetch Strand Loss categories",
        );
      }
      return response.data;
    },
    enabled: !!parentAssetId,
  });

export const useStrandLossCodesQuery = (
  parentAssetId: number | null,
  isSystemDelayCode?: boolean,
) =>
  useQuery({
    queryKey: ["strand-loss-codes", parentAssetId, isSystemDelayCode],
    meta: { realtime: ["DEL.GetDelayCodes"] },
    queryFn: async ({ signal }): Promise<StrandLossCode[]> => {
      const response = await getStrandLossCodes(
        parentAssetId!,
        isSystemDelayCode,
        signal,
      );
      if (!response.ok) {
        throw new Error(
          response.message ?? "Failed to fetch Strand Loss codes",
        );
      }
      return response.data;
    },
    enabled: !!parentAssetId,
  });
